import { createApi } from '@reduxjs/toolkit/query/react';
import AppEnvironment from '../../environment/app-environment';
import { selexpApiBaseQuery } from './selexp-api-base-query';

export const selexpEarningsApiDuck = createApi({
  reducerPath: 'APISelexpEarnings',
  baseQuery: (args, api, extraOptions) => selexpApiBaseQuery(args, { ...api, endpoint: AppEnvironment.selexpEarningsEndpoint! }, extraOptions),
  endpoints: () => ({}),
  keepUnusedDataFor: 3600, // 1 hour
});
